import ChipsInputTable from '../../Table/ChipsInputTable';
import FormSpy from '@data-driven-forms/react-form-renderer/form-spy';
import React from 'react';
import { UseFieldApiConfig } from '@data-driven-forms/react-form-renderer/use-field-api';

export default function ChipsInputTbl(props: UseFieldApiConfig) {
  const {
    subscribeToValues,
    tableData,
    maxHeight,
    setData,
    inputProperty,
    inputValProperty,
    inputHeader,
    data,
    isEdit,
    isDataAvailable
  } = props;
  return (
    <FormSpy subscription={{ values: subscribeToValues ? true : false }}>
      {() => (
        <ChipsInputTable
          tabledata={tableData}
          maxHeightTable={maxHeight}
          setData={setData}
          data={data}
          inputProperty={inputProperty}
          inputValProperty={inputValProperty}
          inputHeader={inputHeader}
          isEdit={isEdit}
          isDataAvailable={isDataAvailable}
        />
      )}
    </FormSpy>
  );
}
